import { useT } from '@/i18n';
import { AuthLayout } from './AuthLayout';

/**
 * What a white-label host shows outside its purpose (WS J): an inactive custom domain (pending, disabled, or no
 * longer in the plan) shows nothing of the app; a review domain serves review links only.
 */
export function HostNotice({ kind }: { kind: 'inactive' | 'review' }) {
  const { t } = useT();
  return kind === 'inactive' ? (
    <AuthLayout title={t('wlInactiveTitle')} sub={t('wlInactiveBody')}>{null}</AuthLayout>
  ) : (
    <AuthLayout title={t('wlReviewOnlyTitle')} sub={t('wlReviewOnlyBody')}>{null}</AuthLayout>
  );
}
